"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bindLanguagesWithLocales = void 0;
const intl_1 = require("../../intl");
/**
 * Group languages by their region independent language code (e.g. "en" for "en-US" and "en-GB").
 */
function bindLanguagesWithLocales(languages) {
    const localesByLangCode = new Map();
    languages.forEach((language) => {
        const languageLocale = intl_1.LocaleObject.fromAnyCode(language.code);
        const regionIndependentLanguageCode = languageLocale.toNeutralLanguageCode();
        let currentLocale = localesByLangCode.get(regionIndependentLanguageCode);
        if (!currentLocale) {
            currentLocale = new Map();
            localesByLangCode.set(regionIndependentLanguageCode, currentLocale);
        }
        currentLocale.set(languageLocale.toHyphenCode(), { language, locale: languageLocale });
    });
    return localesByLangCode;
}
exports.bindLanguagesWithLocales = bindLanguagesWithLocales;
//# sourceMappingURL=bindLanguagesWithLocales.js.map